import React from 'react';
import styled from 'styled-components';
import { UserRoles } from '@bb/users';
import { Contact, Link } from 'components';
import { ModalType } from './TeamGroupModalContext';
import TeamMemberRemovalConfirmation from '../Tables/TeamMemberRemovalConfirmation';

interface UserListProps {
  userType: ModalType;
  users: any[];
  onClickRemove: (id: string) => void;
}

const UserList: React.FC<UserListProps> = ({
  onClickRemove,
  userType,
  users,
}) => {
  const [popconfirmUserId, setPopconfirmUserId] = React.useState<string>(null);

  return (
    <Container>
      {users?.length
        ? users?.map(user => (
            <EntryContainer key={user.id}>
              <Contact
                contact={user}
                avatarSize={32}
                showBranchName
                hoverable={false}
              />

              {userType === 'team' && user.role === UserRoles['Team Admin'] ? (
                <TeamMemberRemovalConfirmation
                  userId={user.id}
                  userRole={user.role}
                  visible={popconfirmUserId === user.id}
                  handleCancel={() => setPopconfirmUserId(null)}
                  handleRemove={() => onClickRemove(user.id)}
                >
                  <RemoveText
                    onClick={e => {
                      setPopconfirmUserId(user.id);
                      e.stopPropagation();
                    }}
                  >
                    Remove
                  </RemoveText>
                </TeamMemberRemovalConfirmation>
              ) : (
                <RemoveText onClick={() => onClickRemove(user.id)}>
                  Remove
                </RemoveText>
              )}
            </EntryContainer>
          ))
        : null}
    </Container>
  );
};

const Container = styled.div`
  margin: 10px 0px;
  padding: 0px 10px;
  max-height: 40vh;
  overflow: auto;
`;

const EntryContainer = styled.div`
  box-shadow: inset 0px -1px 0px #f0f0f0;
  height: 72px;
  display: flex;
  align-items: center;
`;

const RemoveText = styled(Link)`
  margin-left: auto;
`;

export default UserList;
